import mutations from './mutations'
import actions from './actions'

const state = {
  lesson: {},
  quiz: {},
  tasting: {

    
  },
  'tasting-question': {}
}

export default {
  state,
  mutations,
  actions
}
